import { useCallback, useEffect, useState } from "react";
import { api } from "@/lib/api";

function fmt(iso) {
    if (!iso) return "—";
    try { return new Date(iso).toLocaleString("it-IT", { timeZone: "Europe/Rome", day: "2-digit", month: "2-digit", hour: "2-digit", minute: "2-digit" }); }
    catch { return iso; }
}

function ServerSide() {
    const [info, setInfo] = useState(null);
    const [token, setToken] = useState(null);
    const load = useCallback(async () => setInfo((await api.get("/admin/tm-bridge/server")).data), []);
    useEffect(() => { load(); }, [load]);
    const gen = async () => {
        if (info?.has_token && !window.confirm("Generare un nuovo codice? Quello vecchio smetterà di funzionare.")) return;
        setToken((await api.post("/admin/tm-bridge/token")).data.token);
        load();
    };
    return (
        <div data-testid="tm-bridge-server">
            <p className="op-mono text-[11px] text-t8f95a3 leading-relaxed">
                Genera qui il codice e incollalo in preview (Admin → Svincolati → Ponte TM), insieme all&apos;indirizzo di questo sito.
                {info?.has_token && <> Codice attivo dal {fmt(info.created_at)}.</>}
            </p>
            <button onClick={gen} className="op-btn mt-3 text-xs" data-testid="tm-bridge-gen-token">
                {info?.has_token ? "Genera nuovo codice" : "Genera codice ponte"}
            </button>
            {token && (
                <div className="mt-3 op-mono text-[12px]" data-testid="tm-bridge-token">
                    <span className="text-t8f95a3">Codice (copialo ora, non verrà più mostrato): </span>
                    <span className="text-te8ff00 select-all break-all">{token}</span>
                </div>
            )}
        </div>
    );
}

function ClientSide() {
    const [info, setInfo] = useState(null);
    const [url, setUrl] = useState("");
    const [token, setToken] = useState("");
    const [auto, setAuto] = useState(true);
    const [err, setErr] = useState(null);
    const load = useCallback(async () => {
        const { data } = await api.get("/admin/tm-bridge/client");
        setInfo(data);
        if (data.prod_url) setUrl((u) => u || data.prod_url);
        setAuto(data.configured ? data.auto : true);
    }, []);
    useEffect(() => { load(); }, [load]);
    useEffect(() => {
        if (!info?.status?.running) return undefined;
        const t = setInterval(load, 3000);
        return () => clearInterval(t);
    }, [info?.status?.running, load]);

    const act = async (fn) => { setErr(null); try { await fn(); await load(); } catch (e) { setErr(e.response?.data?.detail || e.message); } };
    const save = () => act(() => api.put("/admin/tm-bridge/client", { prod_url: url, token: token || null, auto }));
    const run = () => act(() => api.post("/admin/tm-bridge/run"));
    const st = info?.status || {};

    return (
        <div data-testid="tm-bridge-client">
            <p className="op-mono text-[11px] text-t8f95a3 leading-relaxed">
                Legge dalla produzione gli svincolati con offerte nelle aste non ancora eseguite, aggiorna il prezzo su Transfermarkt
                e lo invia subito in produzione. Con l&apos;aggiornamento automatico si ripete ogni 3 ore finché la preview è accesa.
            </p>
            <div className="grid sm:grid-cols-2 gap-2 mt-3">
                <input className="op-input" placeholder="Indirizzo produzione (https://…)" value={url} onChange={(e) => setUrl(e.target.value)} data-testid="tm-bridge-url" />
                <input className="op-input" placeholder={info?.configured ? "Codice ponte (già salvato)" : "Codice ponte"} value={token} onChange={(e) => setToken(e.target.value)} data-testid="tm-bridge-code" />
            </div>
            <label className="flex items-center gap-2 mt-2 op-mono text-[11px] text-tc9ccd3">
                <input type="checkbox" checked={auto} onChange={(e) => setAuto(e.target.checked)} data-testid="tm-bridge-auto" />
                Aggiorna da solo ogni 3 ore
            </label>
            <div className="flex gap-2 mt-3 flex-wrap">
                <button onClick={save} disabled={!url || (!token && !info?.configured)} className="op-btn text-xs disabled:opacity-40" data-testid="tm-bridge-save">Salva</button>
                <button onClick={run} disabled={!info?.configured || st.running} className="op-btn op-btn-primary text-xs disabled:opacity-40" data-testid="tm-bridge-run">
                    {st.running ? (st.total ? `Aggiornamento… ${st.done || 0}/${st.total}` : "Aggiornamento…") : "Aggiorna prezzi TM e invia in produzione"}
                </button>
            </div>
            {st.started_at && !st.running && (
                <div className="mt-3 op-mono text-[11px]" data-testid="tm-bridge-status">
                    {st.error ? <span className="text-tff3b30">✕ {st.error}</span> : (
                        <span className="text-t7ce38b">✓ Ultimo aggiornamento {fmt(st.finished_at)}: {st.sent}/{st.total} prezzi inviati in produzione.</span>
                    )}
                    {(st.failed || []).length > 0 && (
                        <div className="text-tff7a1a mt-1" data-testid="tm-bridge-failed">
                            Non aggiornati ({st.failed.length}): {st.failed.map((f) => f.name).join(", ")}. Inserisci il valore a mano nella pagina del giocatore in produzione.
                        </div>
                    )}
                </div>
            )}
            {err && <div className="mt-2 text-xs text-tff3b30" data-testid="tm-bridge-error">{err}</div>}
        </div>
    );
}

export default function TmBridgePanel() {
    const host = typeof window !== "undefined" ? window.location.hostname : "";
    const isPreview = host.includes("preview.emergentagent.com") || host === "localhost";
    return (
        <div className="op-card p-5 mb-8" style={{ borderLeft: "3px solid rgb(var(--tc-e8ff00))" }} data-testid="tm-bridge-panel">
            <div className="op-label" style={{ color: "rgb(var(--tc-e8ff00))" }}>// PONTE TM {isPreview ? "(PREVIEW → PRODUZIONE)" : "(PRODUZIONE)"}</div>
            <div className="mt-2">{isPreview ? <ClientSide /> : <ServerSide />}</div>
        </div>
    );
}
